module.exports = __webpack_public_path__ + "img/header-weddingRingsExclusive@2x.8f31e51.webp";